module.exports = __webpack_public_path__ + "img/JKO-gray.5f1fd4cd.png";